export const HIDE_TABBAR_PARAM = 'hideTabbar';
